export function dict_match(object, pattern) {
    for (const key of Object.keys(pattern ?? {})) {
        const specifier = pattern[key];
        if (object == null)
            return false;
        if (specifier != null && typeof specifier === 'object') {
            if (!dict_match(object[key], pattern[key]))
                return false;
        }
        else {
            if (object[key] !== specifier)
                return false;
        }
    }
    return true;
}
